import {http} from '@/utils';
import {PageParams, PageResponse} from '@/types';
import {
  AgentInfo,
  AgentLevelOneTeamReport,
  AgentRewardBetSummary,
  AgentRuleData,
  AgentTeamBetCommissionItem,
  AgentTeamDepositBonusItem,
  AgentTeamDevelopedUserItem,
  AgentTeamUserQueryParams,
  AgentUserInfo,
  CommissionDetailItem,
  CommissionDetailParams,
  CommissionRateItem,
  CommissionRateParams,
  GetUserInfoParams,
  TeamReport,
  TeamReportListItem,
  TeamReportListParams,
  TeamReportParams,
  TodayNewUserItem,
  UserCommissionDetailItem,
  UserCommissionDetailParams,
  UserCommissionInfo,
  UserCommissionInfoParams,
} from './agent.type';

const AGENT_API_PREFIX = 'app/agent';

export function getAgentInfo() {
  return http.post<null, AgentInfo>(`${AGENT_API_PREFIX}/getAgentInfo2`);
}

export function getCommissionRate(params: CommissionRateParams) {
  return http.post<CommissionRateParams, CommissionRateItem[]>(
    `${AGENT_API_PREFIX}/commissionRate`,
    params,
  );
}

export function getTodayNewUser(params: PageParams) {
  return http.post<PageParams, PageResponse<TodayNewUserItem>>(
    `${AGENT_API_PREFIX}/todayNewUser`,
    params,
  );
}

export function getTeamReport(params: TeamReportParams) {
  return http.post<TeamReportParams, TeamReport>(
    `${AGENT_API_PREFIX}/teamReport`,
    params,
  );
}

export function getLevelOneTeamReport(params: TeamReportParams) {
  return http.post<TeamReportParams, AgentLevelOneTeamReport>(
    `${AGENT_API_PREFIX}/teamReport/levelOne`,
    params,
  );
}

export function getRewardBetSummary(params: TeamReportParams) {
  return http.post<TeamReportParams, AgentRewardBetSummary>(
    `${AGENT_API_PREFIX}/teamReport/rewardBetSummary`,
    params,
  );
}

export function getTeamReportList(params: TeamReportListParams) {
  return http.post<TeamReportListParams, PageResponse<TeamReportListItem>>(
    `${AGENT_API_PREFIX}/teamReportList`,
    params,
  );
}

export function getTeamDevelopedUser(params: AgentTeamUserQueryParams) {
  return http.post<
    AgentTeamUserQueryParams,
    PageResponse<AgentTeamDevelopedUserItem>
  >(`${AGENT_API_PREFIX}/teamDevelopedUser`, params);
}

export function getTeamBetCommission(params: AgentTeamUserQueryParams) {
  return http.post<
    AgentTeamUserQueryParams,
    PageResponse<AgentTeamBetCommissionItem>
  >(`${AGENT_API_PREFIX}/teamBetCommission`, params);
}

export function getTeamDepositBonus(params: AgentTeamUserQueryParams) {
  return http.post<
    AgentTeamUserQueryParams,
    PageResponse<AgentTeamDepositBonusItem>
  >(`${AGENT_API_PREFIX}/teamDepositBonus`, params);
}

export function getAgentUserInfo(params: GetUserInfoParams) {
  return http.post<GetUserInfoParams, AgentUserInfo>(
    `${AGENT_API_PREFIX}/getUserInfo`,
    params,
  );
}

export function getCommissionDetail(params: CommissionDetailParams) {
  return http.post<CommissionDetailParams, PageResponse<CommissionDetailItem>>(
    `${AGENT_API_PREFIX}/commissionDetail`,
    params,
  );
}

export function getUserCommissionInfo(params: UserCommissionInfoParams) {
  return http.post<UserCommissionInfoParams, UserCommissionInfo>(
    `${AGENT_API_PREFIX}/userCommissionInfo`,
    params,
  );
}

export function getUserCommissionDetail(params: UserCommissionDetailParams) {
  return http.post<
    UserCommissionDetailParams,
    PageResponse<UserCommissionDetailItem>
  >(`${AGENT_API_PREFIX}/userCommissionDetail`, params);
}

export function getAgentRuleData() {
  return http.post<null, AgentRuleData>(`${AGENT_API_PREFIX}/getAgentRuleData`);
}
